import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import useDirectory from 'hooks/useDirectory'
import { Building } from 'models/Building'
import ViewerLeftBarDetailBuilding from 'pages/building/buildingDetailViewMode/components/ViewerLeftBarDetailBuilding'
import { useRecoilState, useRecoilValue } from 'recoil'
import { currentAnnotation } from 'store/krpanoStore'
import currentViewerState from 'store/viewerStore'
import useSWR from 'swr'
import Utils from 'utils'

import Spinner from 'components/atoms/Spinner'
import ViewerHeader from 'components/organisms/Header/ViewerHeader'

import AnnotationModal from './components/AnnotationModal/AnnotationModal'
import BCPViewerAnnotationModal from './components/BCPAnnotationModal/BCPViewerAnnotationModal'
import ViewerMiniMap from './components/ViewerMiniMap'
import ViewerPanorama from './components/ViewerPanorama'

export default function ViewerBuildingDetail() {
  const { id } = useParams()
  const { navigate, getBuiildingType } = useDirectory()

  const [searchParams] = useSearchParams()
  const floorId = searchParams.get('floor')
  const areaId = searchParams.get('area')
  const pointId = searchParams.get('point')

  const [currentViewer, setCurrentViewer] = useRecoilState(currentViewerState)
  const currentSelected = useRecoilValue(currentAnnotation)

  const {
    data: building,
    isValidating,
    error
  } = useSWR<Building>({
    url: `/v1/buildings/by-type?id=${id}&building_type=${getBuiildingType()}`
  })

  useEffect(() => {
    if (!isValidating && building) {
      if (floorId && areaId && pointId && !currentViewer.isClickToNextFloor) {
        setCurrentViewer((prev) => ({
          ...prev,
          selectedFloor: +floorId,
          selectedArea: areaId,
          selectedPoint: pointId
        }))
        return
      }
      setCurrentViewer((prev) => {
        if (prev.selectedFloor !== null) {
          const isFloorCurrent = building.floors.findIndex(
            (item) => item.id === prev.selectedFloor
          )
          if (isFloorCurrent !== -1) {
            return prev
          }
        }
        const storedFloor = localStorage.getItem('floor')
        if (storedFloor) localStorage.removeItem('floor')
        const defaultFloor = storedFloor ? +storedFloor : building.defaultFloor
        return {
          ...prev,
          selectedFloor: defaultFloor || building.floors[0].id
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [areaId, building, floorId, isValidating, pointId, setCurrentViewer])

  useEffect(() => {
    if (!isValidating && error) {
      Utils.handleErrorNavigate(error, navigate)
    }
  }, [error, isValidating, navigate])

  return (
    <Spinner spinning={isValidating}>
      <div className="h-screen grid grid-rows-[auto_1fr] overflow-x-hidden">
        <ViewerHeader building={building} />

        <div className="relative overflow-y-auto">
          <ViewerLeftBarDetailBuilding floors={building?.floors} />
          {currentViewer.selectedPoint ? <ViewerPanorama /> : null}
          {currentViewer.isOpenMiniMap ? <ViewerMiniMap /> : null}
        </div>

        {currentSelected && getBuiildingType() !== 20 ? (
          <AnnotationModal />
        ) : null}

        {currentSelected && getBuiildingType() === 20 ? (
          <BCPViewerAnnotationModal />
        ) : null}
      </div>
    </Spinner>
  )
}
